<template>
  <v-container fluid fill-width class="ma-0 pa-0">
    <v-row class="ma-0 pa-0">
      <v-col cols="12" class="ma-0 pa-0">
        <v-card color="#eeeeee">
          <v-card-title class="primary--text pl-3 py-2">
            <output-variables-dialog
              ref="output_dialog"
              :show-all-vars-checkbox="
                selectedAnalysisMode == 'Predictor based'
              "
              @dialogOpened="opened"
              @userSelectedOutputVariables="userSelectedOutputVariables"
            />

            <v-divider vertical class="ml-4 mr-4"> </v-divider>

            <v-tooltip bottom color="primary">
              <template v-slot:activator="{ on: tooltip }">
                <span
                  v-on="{ ...tooltip }"
                  @click="$refs.output_dialog.openOutputVariableDialog = true"
                >
                  <v-chip
                    label
                    color="primary"
                    class="white--text title mr-2"
                    >{{
                      selectedAnalysisMode == 'Predictor based'
                        ? outputVariables.length
                        : inputVariables.length > 0
                        ? 1
                        : 0
                    }}</v-chip
                  >
                  <span class="black--text text-body-1"
                    >Variable{{
                      selectedAnalysisMode == 'Predictor based'
                        ? outputVariables.length == 1
                          ? ''
                          : 's'
                        : inputVariables.length > 0
                        ? ''
                        : 's'
                    }}</span
                  >
                </span>
              </template>
              <span class="subtitle-1">
                {{
                  selectedAnalysisMode == 'Predictor based'
                    ? outputVariables.length
                    : inputVariables.length > 0
                    ? 1
                    : 0
                }}
                outcome variable{{
                  selectedAnalysisMode == 'Predictor based'
                    ? outputVariables.length == 1
                      ? ''
                      : 's'
                    : inputVariables.length > 0
                    ? ''
                    : 's'
                }}
                selected
              </span>
            </v-tooltip>

            <!-- <v-spacer /> -->

            <!-- <v-toolbar-items v-if="false">
              <span class="subheading primary--text mt-3 mr-3">Show:</span>
              <v-btn-toggle
                v-model="subset"
                mandatory
                style="background: rgb(255,255,255,0)"
                @change="doHighlightChange()"
              >
                <v-btn
                  text
                  :color="colors['cohort']"
                  class="white--text mr-2 py-1"
                  value="cohort"
                  >Cohort</v-btn
                >
                <v-btn
                  text
                  :color="colors['nonCohort']"
                  class="white--text mr-2 py-1"
                  value="non-cohort"
                  >Non-Cohort</v-btn
                >
              </v-btn-toggle>
            </v-toolbar-items> -->

            <v-tooltip
              v-if="selectedAnalysisMode == 'Outcome based'"
              bottom
              color="primary"
            >
              <template v-slot:activator="{ on: tooltip }">
                <span v-on="{ ...tooltip }">
                  <v-chip
                    label
                    color="primary"
                    class="white--text title mr-2 ml-5"
                    :style="'background: ' + colors['cohort']"
                    >{{ animatedNumber }}</v-chip
                  >
                  <span class="black--text text-body-1">Study Group</span>
                </span>
              </template>
              <span class="subtitle-1">
                {{ animatedNumber }} subject{{
                  animatedNumber == 1 ? '' : 's'
                }}
                in selected study group
                {{
                  Object.keys(queries).length > 0
                    ? ' with the following filters:'
                    : ''
                }}
              </span>
              <br clear="both" />
              <v-list class="primary" dense>
                <v-list-item
                  v-for="(dname, index) in Object.keys(queries).sort()"
                  :key="'ivtsq-' + index"
                >
                  <v-list-item-content class="white--text subtitle-1">
                    {{ queryToString(dname, queries[dname]) }}
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-tooltip>

            <v-tooltip
              v-if="selectedAnalysisMode == 'Outcome based'"
              bottom
              color="primary"
            >
              <template v-slot:activator="{ on: tooltip }">
                <span v-on="{ ...tooltip }">
                  <v-chip
                    label
                    class="black--text title mr-2 ml-5"
                    :style="'background: ' + colors['population']"
                    >{{ unfilteredData.length }}</v-chip
                  >
                  <span class="black--text text-body-1">Population</span>
                </span>
              </template>
              <span class="subtitle-1">
                {{ unfilteredData.length }} subject{{
                  unfilteredData.length == 1 ? '' : 's'
                }}
                in study population
              </span>
            </v-tooltip>

            <v-spacer />

            <v-switch
              v-if="selectedAnalysisMode == 'Outcome based'"
              v-model="useLongScaleNamesSelect"
              label="Use long variable names"
              class="pa-0 ma-0 pr-3"
              hide-details
            ></v-switch>

            <v-chip v-else label class="pa-3"
              >Selected outcome variables will be used in Data Analytics</v-chip
            >

            <!--
      <v-toolbar-items>
        <v-icon v-if="expanded" @click="expandClicked">expand_less</v-icon>
        <v-icon v-else @click="expandClicked">expand_more</v-icon>
      </v-toolbar-items>
      -->
            <v-chip
              v-if="showHelpChip"
              label
              close
              color="#4caf50"
              class="font-weight-bold white--text pa-3 my-5 ml-2"
              @click:close="showHelpChip = false"
              >Review outcome variables.</v-chip
            >
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { state, actions } from '@/store/modules/cohortManager/types';
import OutputVariablesDialog from '@/components/CohortManager/OutputVariablesDialog.vue';
import TWEEN from '@tweenjs/tween.js';
import { colors } from '@/utils/colors';
import { queryToString } from '@/utils/helpers';

export default {
  components: {
    OutputVariablesDialog,
  },
  props: {
    expanded: {
      type: Boolean,
      required: true,
    },
    highlighted: {
      type: Boolean,
      required: true,
    },
    showReviewHelp: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      // subset: 'cohort',
      colors: colors,
      showHelpChip: false,
      tweenData: 0,
      queryToString: queryToString,
    };
  },
  computed: {
    ...mapState('cohortManager', {
      filteredData: state.FILTERED_DATA,
      unfilteredData: state.UNFILTERED_DATA,
      // highlighted_subset: state.HIGHLIGHTED_SUBSET,
      inputVariables: state.INPUT_VARIABLES,
      outputVariables: state.OUTPUT_VARIABLES,
      useLongScaleNames: state.USE_LONG_SCALE_NAMES,
      queries: state.QUERIES,
      selectedAnalysisMode: state.SELECTED_ANALYSIS_MODE,
    }),
    animatedNumber() {
      return this.tweenData.toFixed(0);
    },
    useLongScaleNamesSelect: {
      get() {
        return this.useLongScaleNames;
      },
      set(value) {
        this.setUseLongScaleNames(value);
      },
    },
  },
  watch: {
    filteredData(newData, oldData) {
      const startValue = oldData.length;
      const endValue = newData.length;
      const vm = this;
      function animate() {
        if (TWEEN.update()) {
          requestAnimationFrame(animate);
        }
      }
      new TWEEN.Tween({ tweeningValue: startValue })
        .to({ tweeningValue: endValue }, 1000)
        .easing(TWEEN.Easing.Quadratic.Out)
        .onUpdate(({ tweeningValue }) => {
          vm.tweenData = tweeningValue;
        })
        .start();
      animate();
    },
    showReviewHelp(show) {
      this.showHelpChip = show;
    },
  },
  created() {
    this.tweenData = this.filteredData.length;
    this.useLongScaleNamesSelect = this.useLongScaleNames;
  },
  methods: {
    ...mapActions('cohortManager', {
      // setHighlightedSubset: actions.SET_HIGHLIGHTED_SUBSET,
      setUseLongScaleNames: actions.SET_USE_LONG_SCALE_NAMES,
    }),
    expandClicked() {
      this.$emit('expandClicked', !this.expanded);
    },
    userSelectedOutputVariables() {
      this.$emit('userSelectedOutputVariables', true);
    },
    // highlight(newSubset) {
    //   this.setHighlightedSubset(newSubset);
    // },
    // doHighlightChange() {
    //   if (typeof this.subset === 'undefined') {
    //     this.subset = 'cohort';
    //   }
    //   this.highlight(this.subset);
    // },
    tween(startValue, endValue, prop) {
      const vm = this;
      function animate() {
        if (TWEEN.update()) {
          requestAnimationFrame(animate);
        }
      }
      new TWEEN.Tween({ tweeningValue: startValue })
        .to({ tweeningValue: endValue }, 500)
        .easing(TWEEN.Easing.Quadratic.Out)
        .onUpdate(({ tweeningValue }) => {
          vm[prop] = tweeningValue;
        })
        .start();
      animate();
    },
    getToolbarClass() {
      if (this.highlighted) {
        return 'toolbar_step_highlight';
      } else {
        return '';
      }
    },
    opened() {
      this.$emit('expandClicked', true);
    },
  },
};
</script>

<style scoped>
.horizontal {
  display: flex;
}
.scrollable {
  overflow-x: auto;
}
.scrollable::-webkit-scrollbar {
  display: none;
}
</style>
